$(() => {
    $('body').on('click', '.b-modal-description__plate:not(.is-static)', (e) => {
        const $item = $(e.currentTarget).closest('.b-modal-description__item');
        const $block = $item.closest('.b-modal-description')
        const $modal = $block.find('.b-modal-description__modal');
        const $tabs = $block.find('.b-simple-tabs');
        const index = $item.index() - 2;

        if ($tabs.length) {
            $tabs.trigger('changeTab', index);
        }

        $.fancybox.open($modal, {
            closeExisting: true,
            type: 'inline',
            baseClass: 'b-modal-description__modal-layout',
            slideClass: 'b-modal-description__modal-slide',
            animationEffect: 'slide',
            animationDuration: 400,
            touch: false,
            btnTpl: {
                smallBtn: `
                    <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                        <svg viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line y1="-0.5" x2="37.8844" y2="-0.5" transform="matrix(-0.705147 -0.709061 0.705147 -0.709061 27.7142 27.8573)" stroke="black"/>
                            <line y1="-0.5" x2="37.8855" y2="-0.5" transform="matrix(0.704396 -0.709807 0.704396 0.709807 1.00073 28.8507)" stroke="black"/>
                        </svg>
                    </button>
                `
            },
            beforeShow: (instance, current) => {
            },
            afterShow: (instance, current) => {
                current.$slide.addClass('is-animation-complete')
            },
        });
    })
})